import type { Admin } from '@/types';

const AUTH_KEY = 'auth';

export type StoredAuth = {
  accessToken: string;
  admin: Admin;
};

export const authStorage = {
  get(): StoredAuth | null {
    const raw = localStorage.getItem(AUTH_KEY);
    return raw ? JSON.parse(raw) : null;
  },

  set(data: StoredAuth) {
    localStorage.setItem(AUTH_KEY, JSON.stringify(data));
  },

  clear() {
    localStorage.removeItem(AUTH_KEY);
  },

  getToken(): string | null {
    const auth = this.get();
    return auth?.accessToken ?? null;
  },
};
